import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M12.911 9.1a1.514 1.514 0 0 0-1.5.01l-.91-.53a2.247 2.247 0 0 0 .07-.58 2.324 2.324 0 0 0-.07-.59l.85-.49a1.489 1.489 0 0 0 1.5.01 1.5 1.5 0 0 0-1.48-2.61 1.479 1.479 0 0 0-.76 1.3l-.87.5a2.452 2.452 0 0 0-.99-.57V4.522a1.476 1.476 0 0 0 .75-1.29 1.5 1.5 0 1 0-3 0 1.476 1.476 0 0 0 .75 1.29v1.03a2.489 2.489 0 0 0-1 .57l-.86-.5v-.04a1.5 1.5 0 1 0-1.5 1.5 1.326 1.326 0 0 0 .71-.19l.9.52a2.324 2.324 0 0 0-.07.59 2.247 2.247 0 0 0 .07.58l-.86.5a1.367 1.367 0 0 0-.75-.21 1.5 1.5 0 1 0 1.5 1.51v-.01l.87-.49a2.5 2.5 0 0 0 .99.56v1.04a1.476 1.476 0 0 0-.75 1.29 1.5 1.5 0 0 0 3 0 1.476 1.476 0 0 0-.75-1.29v-1.04a2.552 2.552 0 0 0 .99-.56l.92.52a1.5 1.5 0 1 0 2.25-1.3ZM8 9.062a1.067 1.067 0 0 1-.92-.52A1 1 0 0 1 6.931 8a1.131 1.131 0 0 1 .15-.55 1.074 1.074 0 0 1 1.84 0 1.131 1.131 0 0 1 .15.55 1 1 0 0 1-.15.54A1.067 1.067 0 0 1 8 9.062Z';
const draw24px =
  'M20,14.22a2.05,2.05,0,0,0-2.31.19l-2.07-1.2a3.76,3.76,0,0,0,0-2.42L17.66,9.6a2.07,2.07,0,1,0-.74-1.31l-2.1,1.2A3.78,3.78,0,0,0,12.75,8.3V6a2.05,2.05,0,1,0-1.5,0V8.3A3.78,3.78,0,0,0,9.18,9.49l-2.1-1.2A2,2,0,1,0,6.34,9.6l2.08,1.19a3.76,3.76,0,0,0,0,2.42l-2.08,1.2a2.06,2.06,0,1,0,.74,1.3l2.1-1.2a3.78,3.78,0,0,0,2.07,1.19V18a2.05,2.05,0,1,0,1.5,0V15.7a3.78,3.78,0,0,0,2.07-1.19l2.1,1.2a2,2,0,1,0,3-1.49Zm-8,.06a2.26,2.26,0,1,1,2-1.12A2.28,2.28,0,0,1,12,14.28Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const DotSpokeIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'dotSpoke'),
) as IconWithRender;

DotSpokeIcon.displayName = 'DotSpokeIcon';
DotSpokeIcon.propTypes = Icon.propTypes;
DotSpokeIcon.renderIcon = (props) => <DotSpokeIcon {...props} />;
export default DotSpokeIcon;
